import AxiosInstance from "service/axiosInstance";
import { BaseService } from "./baseService";
import { EventJournal } from "types/Event";
import { AxiosError } from "axios";
import { createErrorResponseStandard } from "utils/functions";

export class EventJournalService extends BaseService {
    private static instance: EventJournalService;
    private constructor() {
        super();
    }

    static getInstance(): EventJournalService {
        if (!EventJournalService.instance) {
            EventJournalService.instance = new EventJournalService();
        }
        return EventJournalService.instance;
    }

    async getEventJournals(params: {
        event_uuid: string;
        start: string;
        end: string;
    }) {
        try {
            const response = await AxiosInstance.get(
                `/events/${params.event_uuid}/journals`,
                {
                    params: {
                        start: params.start,
                        end: params.end,
                    },
                }
            );

            const sortedDtos = [...response.data.data].sort((a, b) =>
                b.create_time.localeCompare(a.create_time)
            );

            return this.handleSuccess<EventJournal[]>({
                ...response,
                data: sortedDtos,
            });
        } catch (error) {
            return this.handleError(error as AxiosError);
        }
    }

    async downloadEventJournals(params: {
        event_uuid: string;
        time_zone: string;
    }) {
        try {
            const response = await AxiosInstance.post(
                `/events/${params.event_uuid}/journals`,
                null,
                {
                    params: { time_zone: params.time_zone },
                    responseType: "blob",
                    headers: { "Content-Type": undefined },
                }
            );
            return response;
        } catch (error) {
            const errorResponse = createErrorResponseStandard(error);
            try {
                errorResponse.data = JSON.parse(
                    await errorResponse.data.text()
                );
            } catch (parseError) {
                console.error("Failed to parse error response:", parseError);
            }
            return errorResponse;
        }
    }
}

export const eventJournalService = EventJournalService.getInstance();
